import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-166d80f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-cy"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "%", -1))
const _hoisted_4 = ["width", "height"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["width", "height"]
const _hoisted_7 = ["stroke"]
const _hoisted_8 = ["width", "height"]
const _hoisted_9 = ["stroke", "stroke-opacity"]
const _hoisted_10 = {
  key: 3,
  class: "tw-absolute edit-percent"
}
const _hoisted_11 = { "clip-path": "url(#clip0_6538_28800)" }
const _hoisted_12 = ["fill"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_6538_28800" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "9",
      height: "9",
      fill: "white"
    })
  ])
], -1))

import { PropType, Ref, computed, onMounted, ref, watch } from "vue";

const colorExcluded = "#EFF0F1";

export default /*#__PURE__*/_defineComponent({
  __name: 'circularProgressPercent',
  props: {
  percent: {
    type: Number as PropType<number>,
    default: 0,
  },
  compensatingOverrideScore: {
    type: Number,
    default: null,
    required: false,
  },
  complianceOverrideScore: {
    type: Number,
    default: null,
    required: false,
  },
  excluded: {
    type: Boolean,
    default: false,
  },
  size: {
    type: Number,
    default: 54,
  },
  textSize: {
    type: Number,
    default: 14,
  },
  id: {
    type: String,
    required: false,
    default: "",
  },
  dataCy: {
    type: String,
    required: false,
    default: "",
  },
},
  setup(__props) {

const props = __props;



const offset: Ref = ref(0);
const actualPercentage: Ref = ref(0);

const isCheckShowWrench = computed(() => {
  return (
    props.complianceOverrideScore?.toString() ||
    props.compensatingOverrideScore?.toString()
  );
});

watch(
  () => props.percent,
  (val) => {
    onChange(val);
  },
);

onMounted(() => {
  onChange(props.percent);
});
const onChange = (val) => {
  let inpVal: number = !val ? 0 : val;
  actualPercentage.value = Math.max(0, Math.min(100, inpVal)).toFixed();
  offset.value = 441.16 + (124 / 100) * (100 - actualPercentage.value);
};

const color = computed(() => {
  if (props.excluded) return colorExcluded;
  if (props.percent >= 66) {
    return "#01893D";
  } else if (props.percent >= 35) {
    return "#FE9A05";
  } else {
    return "#F7553C";
  }
});

const colorCircle = computed(() => {
  if (props.excluded) return colorExcluded;
  if (props.percent >= 66) {
    return "#D9EDE2";
  } else if (props.percent >= 35) {
    return "#FE9A0526";
  } else {
    return "#FEE5E2";
  }
});

const strokeColor = computed(() => {
  if (props.excluded) return colorExcluded;
  if (props.percent >= 66) {
    return "#D9EDE2";
  } else if (props.percent >= 35) {
    return "#FE9A05";
  } else {
    return "#FEE5E2";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: __props.id,
    class: _normalizeClass(`tw-relative tw-w-[${__props.size}px]`)
  }, [
    _createElementVNode("span", {
      class: _normalizeClass(`tw-absolute tw-text-center tw-text-[${__props.textSize}px] tw-not-italic tw-font-[600] tw-leading-[100%] percent`),
      "data-cy": __props.dataCy,
      style: _normalizeStyle(`color: ${color.value}`)
    }, [
      _createTextVNode(_toDisplayString(actualPercentage.value), 1),
      _hoisted_3
    ], 14, _hoisted_2),
    (__props.percent <= 0)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          xmlns: "http://www.w3.org/2000/svg",
          width: __props.size,
          height: __props.size,
          viewBox: "0 0 44 44",
          fill: "none",
          class: "main"
        }, [
          _createElementVNode("path", {
            d: "M22 2C24.6264 2 27.2272 2.51732 29.6537 3.52241C32.0802 4.5275 34.285 6.00069 36.1421 7.85787C37.9993 9.71504 39.4725 11.9198 40.4776 14.3463C41.4827 16.7728 42 19.3736 42 22C42 24.6264 41.4827 27.2272 40.4776 29.6537C39.4725 32.0802 37.9993 34.285 36.1421 36.1421C34.285 37.9993 32.0802 39.4725 29.6537 40.4776C27.2272 41.4827 24.6264 42 22 42C19.3736 42 16.7728 41.4827 14.3463 40.4776C11.9198 39.4725 9.71503 37.9993 7.85786 36.1421C6.00069 34.285 4.5275 32.0802 3.52241 29.6537C2.51731 27.2271 2 24.6264 2 22C2 19.3736 2.51732 16.7728 3.52241 14.3463C4.52751 11.9198 6.0007 9.71503 7.85787 7.85786C9.71505 6.00069 11.9198 4.5275 14.3463 3.5224C16.7729 2.51731 19.3736 2 22 2L22 2Z",
            stroke: __props.excluded ? colorExcluded : '#FEE5E2',
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, _hoisted_5)
        ], 8, _hoisted_4))
      : (__props.percent >= 100)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 1,
            xmlns: "http://www.w3.org/2000/svg",
            width: __props.size,
            height: __props.size,
            viewBox: "0 0 44 44",
            fill: "none",
            class: "main"
          }, [
            _createElementVNode("path", {
              d: "M22 2C24.6264 2 27.2272 2.51732 29.6537 3.52241C32.0802 4.5275 34.285 6.00069 36.1421 7.85787C37.9993 9.71504 39.4725 11.9198 40.4776 14.3463C41.4827 16.7728 42 19.3736 42 22C42 24.6264 41.4827 27.2272 40.4776 29.6537C39.4725 32.0802 37.9993 34.285 36.1421 36.1421C34.285 37.9993 32.0802 39.4725 29.6537 40.4776C27.2272 41.4827 24.6264 42 22 42C19.3736 42 16.7728 41.4827 14.3463 40.4776C11.9198 39.4725 9.71503 37.9993 7.85786 36.1421C6.00069 34.285 4.5275 32.0802 3.52241 29.6537C2.51731 27.2271 2 24.6264 2 22C2 19.3736 2.51732 16.7728 3.52241 14.3463C4.52751 11.9198 6.0007 9.71503 7.85787 7.85786C9.71505 6.00069 11.9198 4.5275 14.3463 3.5224C16.7729 2.51731 19.3736 2 22 2L22 2Z",
              stroke: __props.excluded ? colorExcluded : '#D9EDE2',
              "stroke-width": "4",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_6))
        : (_openBlock(), _createElementBlock("svg", {
            key: 2,
            xmlns: "http://www.w3.org/2000/svg",
            width: __props.size,
            height: __props.size,
            viewBox: "0 0 44 44",
            fill: "none",
            class: "main"
          }, [
            _createElementVNode("circle", {
              cx: "21.9",
              cy: "21.9",
              r: "20",
              stroke: strokeColor.value,
              "stroke-opacity": 
          __props.percent >= 35 && __props.percent < 66 && !__props.excluded ? 0.15 : undefined
        ,
              "stroke-width": "4",
              "stroke-dasharray": "565.48",
              "stroke-dashoffset": "0",
              style: _normalizeStyle(`stroke-dashoffset: ${offset.value}`),
              "stroke-linecap": "round"
            }, null, 12, _hoisted_9)
          ], 8, _hoisted_8)),
    (isCheckShowWrench.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 9 9",
            fill: "white",
            class: "tw-border-[2px] tw-border-solid tw-rounded-full tw-p-[3px] tw-absolute right-[40px] bottom-[45px] tw-bg-white",
            style: _normalizeStyle(`border-color: ${colorCircle.value}`)
          }, [
            _createElementVNode("g", _hoisted_11, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M6.73519 0.0553325C6.22756 -0.0458988 5.7017 -0.00256634 5.21749 0.180396C4.73328 0.363359 4.31017 0.678599 3.99633 1.09023C3.68249 1.50186 3.49053 1.99334 3.44231 2.50871C3.40422 2.91577 3.45701 3.3248 3.5952 3.70675L0.296106 7.00586C-0.0859139 7.38785 -0.0795791 8.00917 0.310152 8.38331L0.670654 8.72936C1.04783 9.09148 1.64487 9.08705 2.01659 8.71933L5.36116 5.41097C5.73034 5.53056 6.12188 5.5717 6.51039 5.53004C7.01998 5.47541 7.5045 5.28051 7.90989 4.967C8.31534 4.65349 8.6259 4.23368 8.80706 3.75422C8.98802 3.27516 9.03264 2.75534 8.93602 2.25245C8.91538 2.14121 8.8716 2.03555 8.80757 1.94225C8.74329 1.84861 8.66004 1.76953 8.56322 1.71014C8.43652 1.6324 8.27304 1.65172 8.16787 1.75684L6.88215 3.04256L6.87804 3.04678C6.84808 3.07788 6.81208 3.10263 6.77235 3.11953C6.73256 3.13643 6.68981 3.14514 6.64661 3.14514C6.60341 3.14514 6.56066 3.13643 6.52087 3.11953C6.48114 3.10263 6.44514 3.07788 6.41518 3.04678C6.40968 3.04107 6.40398 3.03558 6.39807 3.0303L5.9187 2.60138C5.86358 2.54202 5.83284 2.46392 5.83284 2.3827C5.83284 2.29901 5.86548 2.21864 5.92379 2.15866L7.20821 0.874265C7.30091 0.781533 7.32804 0.641755 7.27661 0.521085C7.23013 0.41188 7.16025 0.314226 7.07186 0.235031C6.9834 0.155838 6.87868 0.0970383 6.76509 0.0627948C6.75525 0.0598314 6.74522 0.0573412 6.73519 0.0553325Z",
                fill: color.value
              }, null, 8, _hoisted_12)
            ]),
            _hoisted_13
          ], 4))
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})